
function Start({ ready, live }) {
  return (
    <div style={{ display: "flex", minHeight: "100vh", justifyContent: "center", alignItems: "center" }}>
      <small>
        {ready ? (live ? 'Opdateret ✔️' : 'Data er ikke live') : 'Henter data...'}
      </small>
    </div>
  )

}

export default Start